<main id="main-content" class="main-content">
  <h2 class="form-header">Regional Approval & Certification</h2>

  <mat-card>
    <h2 class="forest-title">Regional Line Officer(s)</h2>
    @if (regionContacts.length > 0) {
      <div>
        <div class="contact-container">
          @for (user of regionContacts; track user) {
            <mat-card class="contact-card">
              <div>
                <div class="user-cell-name">
                  <div class="user-icon">
                    <p>{{user.first_name[0]}}</p>
                  </div>
                  <a [routerLink]="['/user']" [queryParams]="{user_id: user?.user_id}"
                  class="user-name">{{user.first_name + " " + user.last_name}}</a>
                </div>
                <div class="user-cell-details">
                  @for (role of user.showRoles; track role) {
                    <mat-chip>{{ role }}</mat-chip>
                  }
                  <div class="details-number"><mat-icon>phone</mat-icon> {{(user.phone_num | phone) ||
                  "--"}}
                </div>
                <div class="details-email"><mat-icon>email</mat-icon>{{user.email}}</div>
                @if (user.isROLO.length > 0) {
                  <div class="details-email"><mat-icon>location_on</mat-icon>Region {{ user.isROLO[0].region }}</div>
                }
              </div>
            </div>
          </mat-card>
        }
      </div>
    </div>
  }
</mat-card>
</main>